import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { colors } from '@src/styles';

const skeletonSX = { backgroundColor: 'rgba(255, 255, 255, 0.06)' } as const;

export const CanonicalCardSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        minHeight: 52,
        padding: '8px 14px',
        boxSizing: 'border-box',
        backgroundColor: colors.brand.surface,
        border: `1px solid ${colors.brand.line}`,
        borderRadius: '10px',
      }}
    >
      <Skeleton variant="text" width={220} height={20} sx={skeletonSX} />
      <Skeleton variant="text" height={16} sx={{ ...skeletonSX, flex: 1 }} />
      <Skeleton variant="rounded" width={56} height={20} sx={{ ...skeletonSX, borderRadius: '999px' }} />
      <Skeleton variant="text" width={110} height={16} sx={skeletonSX} />
    </Box>
  );
};
